import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

function AppShellSkeleton() {
  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar skeleton — desktop only */}
      <div className="hidden md:flex w-64 flex-col border-r bg-card">
        <div className="flex h-14 items-center border-b px-4">
          <div className="h-7 w-28 rounded bg-muted animate-pulse" />
        </div>
        <div className="flex flex-col gap-1 p-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-9 rounded-md bg-muted animate-pulse" style={{ opacity: 1 - i * 0.1 }} />
          ))}
        </div>
      </div>

      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Navbar skeleton */}
        <div className="flex h-14 items-center border-b px-4 gap-3 bg-card">
          <div className="md:hidden h-7 w-24 rounded bg-muted animate-pulse" />
          <div className="flex-1" />
          <div className="h-8 w-8 rounded-full bg-muted animate-pulse" />
        </div>

        {/* Content skeleton */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="max-w-2xl space-y-4">
            <div className="h-8 w-48 rounded bg-muted animate-pulse" />
            <div className="h-4 w-72 rounded bg-muted animate-pulse" />
            <div className="grid gap-3 mt-6">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="h-24 rounded-xl bg-muted animate-pulse" style={{ opacity: 1 - i * 0.2 }} />
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) return <AppShellSkeleton />

  if (!user) return <Navigate to="/" replace />

  return <>{children}</>
}
